// Neutral gray pastille behind every panel/section icon across the app — color is kept for
// things that carry meaning (statuses, stock levels, amounts), not decoration.
export const SECTION_ICON_STYLE = { background: '#f1f5f9', color: '#42464d' };
